// api/nominatim.ts
import axios from "axios";

export const nominatim = axios.create({
  baseURL: "https://nominatim.openstreetmap.org",
  headers: {
    "User-Agent": "unydoapp/1.0",
    "Referer": window.location.origin,
  },
});
